import { getConfig } from "./config.ts";

/**
 * Redirect the user to the login page.
 */
export function redirectToLogin(): void {
	window.location.href = `${getConfig("identityServiceUrl")}api/enter?redirect_url=${document.location.href}`;
}
